/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/261-point-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.5 15H9a1.502 1.502 0 001.307-2.236 1.5 1.5 0 00.31-2.264 1.494 1.494 0 00.297-1.5H14.5c.827 0 1.5-.673 1.5-1.5S15.327 6 14.5 6H8.333l1.466-2.75a1.502 1.502 0 00-2.381-1.789l-.011.012L4 5.21V4.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-.691l2.276 1.138A.496.496 0 006.5 15zm-4-1a.5.5 0 110-1 .5.5 0 010 1zm4.118 0L4 12.691V6.694L8.143 2.15a.5.5 0 01.782.614l-1.866 3.5a.502.502 0 00.442.735h7a.5.5 0 010 1h-5a.5.5 0 000 1 .5.5 0 010 1 .5.5 0 000 1 .5.5 0 010 1h-.5a.5.5 0 000 1 .5.5 0 010 1H6.619z"/>'
  }
})
